import './CourseLayout.css'
import React from 'react'
import BackHome from 'components/back-home'
import { THEME_PATH } from 'routes/path'

/**
 * 课程布局
 */
export default function CourseLayout({ children, theme }) {
    return (
        <div className='course__layout'>
            {children}
            <BackHome theme={theme} path={THEME_PATH(theme)} />
        </div>
    )
}